var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 8.52734L6.3246 9.14934H16.8968V17.1718H5.88927L4.89424 16.0523L4.58301 8.52734Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7543 9.42036H7.23054C6.52111 9.42036 5.85563 9.06204 5.45263 8.47307C5.84511 7.8999 6.49573 7.52452 7.23054 7.52452H18.9924C19.1633 7.52452 19.302 7.38297 19.302 7.20855C19.302 7.03413 19.1633 6.89258 18.9924 6.89258H7.23054C5.69221 6.89258 4.44482 8.16595 4.44482 9.73633V16.6877C4.44482 18.2581 5.69221 19.5315 7.23054 19.5315H17.7543C18.6093 19.5315 19.302 18.8243 19.302 17.9516V11.0002C19.302 10.1275 18.6093 9.42036 17.7543 9.42036ZM18.6829 17.9516C18.6829 18.4742 18.2663 18.8995 17.7543 18.8995H7.23054C6.03578 18.8995 5.06387 17.9074 5.06387 16.6877V9.73633C5.06387 9.51641 5.09544 9.30408 5.15425 9.10375C5.67797 9.69904 6.43197 10.0523 7.23054 10.0523H17.7543C18.2663 10.0523 18.6829 10.4776 18.6829 11.0002V17.9516ZM17.4448 14.4759C17.4448 14.8247 17.1675 15.1079 16.8258 15.1079C16.4841 15.1079 16.2067 14.8247 16.2067 14.4759C16.2067 14.1271 16.4841 13.844 16.8258 13.844C17.1675 13.844 17.4448 14.1271 17.4448 14.4759Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31055 15.918L6.4502 12.85",
    stroke: "#5260FE",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41602 12.9004L6.45003 15.8664",
    stroke: "#5260FE",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWallet);
export default __webpack_public_path__ + "static/media/CloseWallet.b8c71323082abeb3b0db2873c60e1b6b.svg";
export { ForwardRef as ReactComponent };